<template>
  <div class="monthly-car">
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label>购买月卡时间:</label>
            <bosk-shortcut-date
              v-on:current-date-change="onCurrentDateChange"
            ></bosk-shortcut-date>
          </div>
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              clearable
              v-model="search.plateNumber"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group">
            <label for>手机号:</label>
            <input
              clearable
              v-model="search.phone"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="searchList"
                type="primary"
                :loading="loading"
                 size="small"
              >
                查询
              </el-button>
            </span>
            <span class="add_btn">
              <el-button
                type="default"
                @click="addOrEdit()"
              >
                添加
              </el-button>
            </span>
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              导出
            </button>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          v-loading="loading"
          :summary-method="getSummaries"
          show-summary
        >
          <!-- <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="会员卡车辆"
            prop="plateNumber"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="会员卡车型" prop="">
            <template slot-scope="scope">
              {{
                scope.row.carType == null || scope.row.carType == ""
                  ? "全部"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车主姓名"
            prop="userName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="联系手机"
            prop="phone"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="会员卡名称"
            prop="chargeName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="会员卡价格(元)"
            prop="amount"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="适用车场"
            prop="parkingNames"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="账单金额"
            prop="realPay"
          ></el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="月卡开始时间"
            prop="startDate"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="月卡结束时间"
            prop="endDate"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="支付时间"
            prop="payTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="备注"
            prop="attr2"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="250px">
            <template slot-scope="scope">
              <button
                type="button"
                class="edit"
                @click="monthlyOrder(scope.row)"
              >
                续费
              </button>
              <!-- <button
                type="button"
                class="edit"
                @click="getRentMonthUserIntervals(scope.row.id)"
              >
                开通时段
              </button> -->
              <button
                type="button"
                class="edit"
                @click="addOrEdit(scope.row.id)"
              >
                修改
              </button>
              <button class="delete" @click="del(scope.row.id)">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
    <!--添加或修改月租车用户-->
    <el-dialog
      title="添加或修改月租车用户"
      :visible.sync="monthlyUserDialogVisible"
      width="30%"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="resetUserForm"
    >
      <el-form
        ref="userForm"
        class="user-form"
        :model="monthlyFormUser"
        label-width="80px"
        :rules="rules"
      >
        <div v-if="monthlyFormUser.id" class="old-plate-number">
          <span class="old-plate-number-name">原车牌号:</span>
          <span class="old-plate-number-value">{{
            monthlyFormUser.oldPlateNumber
          }}</span>
        </div>
        <div v-if="!monthlyFormUser.id" class="monthly-info">
          **月租车主信息
        </div>
        <el-form-item label="物业" prop="propertyId">
          <el-select
            class="check-property"
            filterable
            clearable
            v-model.trim="monthlyFormUser.propertyId"
          >
            <el-option
              v-for="item in propertyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="monthlyFormUser.id ? '新车牌号' : '车牌号'"
          prop="plateNumber"
        >
          <template>
            <!-- <el-input
              class="read-only"
              v-if="monthlyFormUser.id"
              v-model="monthlyFormUser.plateNumber"
              readonly
            ></el-input> -->
            <!-- <el-input v-else v-model="monthlyFormUser.plateNumber"></el-input> -->
            <div>
              <div class="plateNumber">
                <div @click="dropdown" class="plateNumber-firstTwo">
                  <span>{{ plateNumber.first }}{{ plateNumber.second }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <div>
                  <template>
                    <el-input
                      v-if="!monthlyFormUser.id"
                      v-model="monthlyFormUser.plateNumber"
                    ></el-input>
                    <el-input
                      ref="modifyPlateNumber"
                      v-else
                      v-model="monthlyFormUser.plateNumber"
                    ></el-input>
                  </template>
                </div>
              </div>
              <div class="plateNumber-firstTwo-spread" v-if="showSpreadTab">
                <table class="firstLetter" v-if="showFirstLetter">
                  <tr>
                    <td @click="getFirstLetter('京')">京</td>
                    <td @click="getFirstLetter('津')">津</td>
                    <td @click="getFirstLetter('沪')">沪</td>
                    <td @click="getFirstLetter('渝')">渝</td>
                    <td @click="getFirstLetter('冀')">冀</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('豫')">豫</td>
                    <td @click="getFirstLetter('鲁')">鲁</td>
                    <td @click="getFirstLetter('新')">新</td>
                    <td @click="getFirstLetter('苏')">苏</td>
                    <td @click="getFirstLetter('浙')">浙</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('赣')">赣</td>
                    <td @click="getFirstLetter('鄂')">鄂</td>
                    <td @click="getFirstLetter('桂')">桂</td>
                    <td @click="getFirstLetter('甘')">甘</td>
                    <td @click="getFirstLetter('晋')">晋</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('蒙')">蒙</td>
                    <td @click="getFirstLetter('陕')">陕</td>
                    <td @click="getFirstLetter('吉')">吉</td>
                    <td @click="getFirstLetter('闽')">闽</td>
                    <td @click="getFirstLetter('贵')">贵</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('粤')">粤</td>
                    <td @click="getFirstLetter('青')">青</td>
                    <td @click="getFirstLetter('藏')">藏</td>
                    <td @click="getFirstLetter('川')">川</td>
                    <td @click="getFirstLetter('宁')">宁</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('琼')">琼</td>
                    <td @click="getFirstLetter('黑')">黑</td>
                    <td @click="getFirstLetter('辽')">辽</td>
                    <td @click="getFirstLetter('皖')">皖</td>
                    <td @click="getFirstLetter('湘')">湘</td>
                  </tr>
                  <tr>
                    <td @click="getFirstLetter('黔')">黔</td>
                    <td @click="getFirstLetter('滇')">滇</td>
                    <td @click="getFirstLetter('使')">使</td>
                    <td @click="getFirstLetter('领')">领</td>
                  </tr>
                </table>

                <table class="secondLetter" v-if="showSecondLetter">
                  <tr>
                    <td @click="getSecondLetter('A')">A</td>
                    <td @click="getSecondLetter('B')">B</td>
                    <td @click="getSecondLetter('C')">C</td>
                    <td @click="getSecondLetter('D')">D</td>
                    <td @click="getSecondLetter('E')">E</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('F')">F</td>
                    <td @click="getSecondLetter('G')">G</td>
                    <td @click="getSecondLetter('H')">H</td>
                    <td @click="getSecondLetter('I')">I</td>
                    <td @click="getSecondLetter('J')">J</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('K')">K</td>
                    <td @click="getSecondLetter('L')">L</td>
                    <td @click="getSecondLetter('M')">M</td>
                    <td @click="getSecondLetter('N')">N</td>
                    <td @click="getSecondLetter('O')">O</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('P')">P</td>
                    <td @click="getSecondLetter('Q')">Q</td>
                    <td @click="getSecondLetter('R')">R</td>
                    <td @click="getSecondLetter('S')">S</td>
                    <td @click="getSecondLetter('T')">T</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('U')">U</td>
                    <td @click="getSecondLetter('V')">V</td>
                    <td @click="getSecondLetter('W')">W</td>
                    <td @click="getSecondLetter('X')">X</td>
                    <td @click="getSecondLetter('Y')">Y</td>
                  </tr>
                  <tr>
                    <td @click="getSecondLetter('Z')">Z</td>
                  </tr>
                </table>
              </div>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="monthlyFormUser.phone"></el-input>
        </el-form-item>
        <el-form-item label="车主姓名" prop="name">
          <el-input v-model="monthlyFormUser.name"></el-input>
        </el-form-item>
        <el-form-item label="车辆编号" prop="attr1">
          <el-input v-model="monthlyFormUser.attr1"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="attr2">
          <el-input type="textarea" v-model="monthlyFormUser.attr2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确 定</el-button>
        <el-button @click="monthlyUserDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--开通时段-->
    <el-dialog
      title="开通时段"
      :visible.sync="openingPeriodDialogVisible"
      width="600px"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <template>
        <ul v-if="openingPeriodData.length > 0">
          <li v-for="item in openingPeriodData" :key="item.id">
            <span>
              <span class="openingPeriod-info">道路名称:</span>
              <span class="openingPeriod-data">{{
                JSON.parse(item.parkingId).parkingName
              }}</span>
            </span>
            <span>
              <span class="openingPeriod-info">开始时间:</span>
              <span class="openingPeriod-data">{{ item.startDate }}</span>
            </span>
            <span>
              <span class="openingPeriod-info">结束时间:</span>
              <span class="openingPeriod-data">{{ item.endDate }}</span>
            </span>
          </li>
        </ul>
        <div v-else class="no-data">暂无数据</div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import AreaTree from "../../commons/areaTree";

import {
  rentMonthUserIntervals,
  monthlyUserList,
  monthlyUserOne,
  fetchPropertyList,
} from "@/api/url";

import Page from "../../commons/page";

// import Refresh from "../commons/refresh.vue";

export default {
  name: "monthly-car",
  data() {
    return {
      totalMap: {},
      moduleName: "parking",
      monthlyUserDialogVisible: false,
      showFirstLetter: false,
      showSecondLetter: false,
      showSpreadTab: false,
      openingPeriodDialogVisible: false,
      openingPeriodData: [],
      propertyList: [],

      plateNumber: {
        first: "粤",
        second: "B",
        remain: "",
      },
      monthlyFormUser: {
        id: "",
        name: "",
        plateNumber: "",
        oldPlateNumber: "",
        phone: "",
        propertyId: null,
        attr1: "",
        attr2: "",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        plateNumber: "",
        phone: "",
        propertyId: null,
        startTime: null,
        endTime: null,
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      tableListData: [],
      rentMonthUserIntervalsData: [],
      rules: {
        propertyId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
        // name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        plateNumber: [
          { required: true, message: "请填写车牌", trigger: "blur" },
          // {
          // 	required: true,
          // 	trigger: 'blur',
          // 	validator:(rule,value,callback)=>{
          // 		if(value!= ""){
          //             if(( /^(((([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/).test(value) == false){
          //                 callback(new Error('车牌号输入有误'));
          //             }else{
          //                 callback();
          //             }
          //         }else{
          //             callback(new Error("请填写车牌号"));
          //         }
          // 	}
          // }
        ],

        // phone: [
        //   {
        //     required: true,
        //     trigger: "blur",
        //     validator: (rule, value, callback) => {
        //       if (value != "") {
        //         if (
        //           /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
        //             value
        //           ) == false
        //         ) {
        //           callback(new Error("请填写正确手机号"));
        //         } else {
        //           callback();
        //         }
        //       } else {
        //         callback(new Error("请填写手机号"));
        //       }
        //     },
        //   },
        // ],
      },
      pageObj: {},
      loading: false,
    };
  },
  filters: {
    handelIsRent(value) {
      let v;
      switch (value) {
        case 1:
          v = "有效";
          break;
        case 0:
          v = "无效";
          break;
        default:
          v = "无效";
      }
      return v;
    },
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      const {
        propertyId,
        pageSize,
        phone,
        plateNumber,
        startTime,
        endTime,
      } = this.search;
      this.$get(monthlyUserList(), {
        parentId: propertyId ? propertyId : null,
        enabledFlag: "y",
        limit: pageSize,
        page: curPage,
        phone: phone ? phone : null,
        plateNumber: plateNumber ? plateNumber : null,
        startTime,
        endTime,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.pageObj = { ...pageObj };
        // _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.totalMap = data.data.totalMap;
        _this.tableListData = rows.map((item) => {
          // if (item.parentId && typeof JSON.parse(item.parentId) === "object") {
          //   item.propertyName = JSON.parse(item.parentId).name;
          // }
          return item;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    addOrEdit(id) {
      this.monthlyFormUser.id = id;
      if (id) {
        this.monthlyUserDialogVisible = true;
        this.$nextTick(() => {
          this.$refs.modifyPlateNumber.focus();
        });
        this.$get(monthlyUserOne() + "/" + this.monthlyFormUser.id).then(
          (data) => {
            let d = data.data;
            this.monthlyFormUser.plateNumber = d.plateNumber.slice(2);
            this.plateNumber.first = d.plateNumber.slice(0, 1);
            this.plateNumber.second = d.plateNumber.slice(1, 2);
            this.monthlyFormUser.name = d.userName;
            this.monthlyFormUser.phone = d.phone;
            this.monthlyFormUser.propertyId = d.parentId;
            this.monthlyFormUser.attr1 = d.attr1;
            this.monthlyFormUser.attr2 = d.attr2;
            this.monthlyFormUser.oldPlateNumber = d.plateNumber;
          }
        );
      } else {
        this.monthlyUserDialogVisible = true;
        this.monthlyFormUser.plateNumber = "";
        this.monthlyFormUser.name = "";
        this.monthlyFormUser.phone = "";
        this.monthlyFormUser.propertyId = null;
        this.monthlyFormUser.attr1 = "";
        this.monthlyFormUser.attr2 = "";
      }
    },
    addOrEditTrue() {
      var _this = this;
    
      this.$refs["userForm"].validate(function(valid, noStri) {
        if (valid) {
          _this.monthlyUserDialogVisible = false;
          let plateNumber =
            _this.plateNumber.first +
            _this.plateNumber.second +
            _this.monthlyFormUser.plateNumber;
          //添加月租车用户
          if (!_this.monthlyFormUser.id) {
            _this
              .$postRequest(monthlyUserOne(), {
                parentId: _this.monthlyFormUser.propertyId,
                plateNumber: plateNumber,
                userName: _this.monthlyFormUser.name,
                phone: _this.monthlyFormUser.phone,
                attr1: _this.monthlyFormUser.attr1,
                attr2: _this.monthlyFormUser.attr2,
              })
              .then((data) => {
                if (data.status != 200) return;
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功!",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
            //修改月租车用户
          } else {
            _this
              .$putRequest(monthlyUserOne() + "/" + _this.monthlyFormUser.id, {
                id: _this.monthlyFormUser.id,
                parentId: _this.monthlyFormUser.propertyId,
                plateNumber: plateNumber,
                userName: _this.monthlyFormUser.name,
                phone: _this.monthlyFormUser.phone,
                attr1: _this.monthlyFormUser.attr1,
                attr2: _this.monthlyFormUser.attr2,
              })
              .then((data) => {
                if (data.status != 200) return;
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功!",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    searchList: function() {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.userName = "";
    },
    del(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);
          _this.$deleteRequest(monthlyUserOne() + "/" + id).then((data) => {
            if (data.status != 200)
              return _this.$layer.msg("删除失败", { time: 1 });
            _this.$notify({
              type: "success",
              title: "成功",
              message: "删除成功!",
            });
            _this.tableList(_this.pageObj.curIndex);
          });
        }
      );
    },
    monthlyOrder(row) {
      if (!row) return;
      this.$router.push({
        path: "/main/vehicleManagement/monthlyCar/renewal",
        query: {
          recordId: row.id,
          road: row.parentId,
          // 会员卡信息随 query 带入续费页顶部展示
          plateNumber: row.plateNumber || "",
          userName: row.userName || "",
          phone: row.phone || "",
          chargeName: row.chargeName || "",
          startDate: row.startDate || "",
          endDate: row.endDate || "",
        },
      });
    },
    dropdown() {
      if (this.showSpreadTab) {
        this.showSpreadTab = false;
      } else {
        this.showSpreadTab = true;
      }
      this.showFirstLetter = true;
      this.showSecondLetter = false;
    },
    getFirstLetter(l) {
      this.plateNumber.first = l;
      this.showFirstLetter = false;
      this.showSecondLetter = true;
    },
    getSecondLetter(l) {
      this.plateNumber.second = l;
      this.showSpreadTab = false;
      this.showFirstLetter = false;
      this.showSecondLetter = false;
    },
    openingPeriod(d) {
      this.openingPeriodDialogVisible = true;
    },
    resetUserForm() {
      this.$refs["userForm"].resetFields();
    },
    getRentMonthUserIntervals(userId) {
      let _this = this;
      this.openingPeriodDialogVisible = true;
      this.$get(rentMonthUserIntervals(), {
        userId,
      }).then((data) => {
        if (data.status != 200) return;
        _this.openingPeriodData = data.data;
      });
    },
    resetUserForm() {
      this.$refs["userForm"].resetFields();
    },
    getAllProperty() {
      this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    downloadData() {
      const { propertyId, pageSize, phone, plateNumber } = this.search;
      this.$downloadFileRequest(
        "/api/parking/rentMonthUser/rentMonthUserExport",
        {
          parentId: propertyId ? propertyId : null,
          enabledFlag: "y",
          phone: phone ? phone : null,
          plateNumber: plateNumber ? plateNumber : null,
          startTime,
          endTime
        },
        "月租车辆"
      );
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
        }
        if (index === 7) {
          sums[index] = this.totalMap?.realPayTotal ?? 0;
        }
      });
      return sums;
    },
    onCurrentDateChange(date) {
      this.search.startTime = date?.[0] ?? null;
      this.search.endTime = date?.[1] ?? null;
    },
  },

  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      // this.manager_btn_edit = this.elements['manager:btn_edit'];
      // this.manager_btn_delete = this.elements['manager:btn_delete'];
    },
  },
  components: {
    Page,
    // Refresh,
    AreaTree,
  },
  created: function() {
    // this.permiss;
  },
  mounted: function() {
    this.getAllProperty();
    this.tableList(this.search.pageNumber);
  },
  // watch: {
  //     elements: {
  //      	handler: function (val, oldVal) {
  //      		this.permiss;
  //      	},
  //       	deep: true
  //     }
  // }
};
</script>
<style scoped>
.monthly-info {
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  color: #aaa;
  font-size: 16px;
}
.plateNumber {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.plateNumber-firstTwo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.plateNumber div:first-child {
  width: 20%;
}
.plateNumber div:last-child {
  width: 100%;
}
.plateNumber-firstTwo-spread {
  position: absolute;
  z-index: 1000;
  background: white;
  box-shadow: 0 0 10px #ccc;
}
.plateNumber-firstTwo-spread table tr td {
  width: 40px;
  height: 40px;
  border: 1px solid #eee;
  color: #278cd8;
  text-align: center;
}
.plateNumber-firstTwo-spread table tr {
  border: 1px solid #ccc;
}
.plateNumber-firstTwo,
.plateNumber-firstTwo-spread table tr td {
  cursor: pointer;
}
ul li {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
}
.openingPeriod-info {
  display: inline-block;
  margin-right: 10px;
  color: #999;
}
/* .openingPeriod-data{
	font-size:18px;
} */
.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
}
.old-plate-number {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.old-plate-number-name {
  font-size: 16px;
  font-weight: bold;
  padding-right: 10px;
  color: red;
}
.old-plate-number-value {
  font-size: 20px;
  font-weight: bold;
  color: red;
}
</style>
<style>
.read-only .el-input__inner {
  background-color: #eee !important;
}
.user-form .el-select {
  width: 100%;
}
.monthly-car .el-date-editor.el-input__inner {
  width: 100%;
  max-width: 100%;
}
.monthly-car .el-table__footer-wrapper tbody td.el-table__cell{
  color:red;
}
</style>
